export enum LightStringProductType {
  Unknown = 0,
  House = 1,
  TreeWell = 2,
  Track = 3,
  Billiard = 4,
  Wall = 5,
  WallRecessed = 6,
  Flood = 7,
  Pathway = 8
}
export interface DeviceWithRegistrationInformation {
  associatedHubSerialNumber: string;
  associatedHubName: string;
  propertyName: string;
  ownerName: string;
  isRegistered: boolean;
  isConfigured: boolean;
  registeredName: string;
  registrationDate: Date | null;
  deviceType: string | undefined;
  id: string | undefined;
  lightStringProductTypeID: LightStringProductType | undefined;
  firmwareVersion: string | undefined;
  serialNumber: string | undefined;
  macAddress: string | undefined;
  identifier: string | undefined;
  manufactureDate: Date | undefined;
  hardwareRevision: string | undefined;
  lotNumber: string | undefined;
  notes: string | undefined;
  registeredHubID: string | null | undefined;
  wasConnectionAttemptSuccessful: boolean | null | undefined;
  lastConnectionAttemptTime: Date | null | undefined;
}
export interface HubWithDetails {
  propertyID: string | null | undefined;
  propertyName: string | undefined;
  propertyOwnerID: string | null | undefined;
  propertyIsBeingTransferred: boolean | undefined;
  currentUserIsOwner: boolean | undefined;
  currentUserHasAccess: boolean | undefined;
  currentUserCanConfigure: boolean | undefined;
  registrationID: string | null | undefined;
  hubIsRegistered: boolean | undefined;
  registeredName: string | undefined;
  registrationDate: Date | null | undefined;
  isConfigured: boolean | undefined;
  registeredControllerIDs: Array<string> | undefined;
  id: string | undefined;
  firmwareVersion: string | undefined;
  acknowledgementDisabled: boolean | undefined;
  serialNumber: string | undefined;
  macAddress: string | undefined;
  identifier: string | undefined;
  manufactureDate: Date | undefined;
  hardwareRevision: string | undefined;
  lotNumber: string | undefined;
  notes: string | undefined;
  created: Date | undefined;
  createdBy: string | null | undefined;
  updated: Date | null | undefined;
  updatedBy: string | null | undefined;
}
export interface Person {
  id: string | undefined;
  environmentID: string | null | undefined;
  securityCredentialID: string | null | undefined;
  personalIdentifier: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  languageID: string | null | undefined;
  tagIDJson: string | undefined;
  archivedDate: Date | null | undefined;
  created: Date | undefined;
  createdBy: string | null | undefined;
  updated: Date | null | undefined;
  updatedBy: string | null | undefined;
}
export interface GeoDbPlace {
  id: number | undefined;
  wikiDataId: string | undefined;
  type: string | undefined;
  city: string | undefined;
  name: string | undefined;
  country: string | undefined;
  countryCode: string | undefined;
  region: string | undefined;
  regionCode: string | undefined;
  regionWdId: string | undefined;
  elevationMeters: number | null | undefined;
  latitude: number | null | undefined;
  longitude: number | null | undefined;
  population: number | null | undefined;
  timezone: string | undefined;
  distance: number | null | undefined;
  deleted: boolean | null | undefined;
  placeType: string | undefined;
  created: Date | null | undefined;
  updated: Date | null | undefined;
  detailsUpdated: Date | null | undefined;
}
export interface PropertyWithDetails {
  place: GeoDbPlace;
  owner: Person;
  currentUserIsOwner: boolean | undefined;
  currentUserHasAccess: boolean | undefined;
  currentUserCanConfigure: boolean | undefined;
  id: string | undefined;
  name: string | undefined;
  isTestProperty: boolean | undefined;
  timezone: string | undefined;
  geoDbPlaceID: number | null | undefined;
  isPrimary: boolean | undefined;
  ownerID: string | undefined;
  transferringToPersonID: string | null | undefined;
  created: Date | undefined;
  createdBy: string | null | undefined;
  updated: Date | null | undefined;
  updatedBy: string | null | undefined;
  archivedDate: Date | null | undefined;
}

export * from "./systemConfigurationService";
export * from "./noticeService";
export * from "./propertyService";
export * from "./hubService";

